export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/transmissionIcon.76086c0a.svg","height":21,"width":20,"blurWidth":0,"blurHeight":0};